/* Formatação locale-aware (Intl nativo, sem lib). Backoffice MVP em pt-BR. */
const LOCALE = 'pt-BR';

/* Moeda suportada pelos DTOs de métricas (mrrUsd/mrrBrl). Fonte única do union para o
   toggle page-level e os formatadores. */
export type Currency = 'BRL' | 'USD';

export function fmtDate(iso: string): string {
  return new Date(iso).toLocaleDateString(LOCALE, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function fmtDateTime(iso: string): string {
  return new Date(iso).toLocaleString(LOCALE, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/* Tick curto p/ eixo X de gráfico (sem ano). */
export function fmtDateShort(iso: string): string {
  return new Date(iso).toLocaleDateString(LOCALE, { day: '2-digit', month: 'short' });
}

/* Moeda em unidade maior (o backend já divide cents → reais/dólares, ADR-0353). Locale
   segue a moeda: BRL→pt-BR, USD→en-US. */
export function fmtCurrency(value: number, currency: Currency = 'BRL'): string {
  return new Intl.NumberFormat(currency === 'BRL' ? 'pt-BR' : 'en-US', {
    style: 'currency',
    currency,
  }).format(value);
}

/* Churn/percentuais chegam em 0..100 (já em %, ADR-0353) — só formata. */
export function fmtPercent(value: number): string {
  return `${value.toFixed(1)}%`;
}

export function fmtNumber(value: number): string {
  return new Intl.NumberFormat(LOCALE).format(value);
}

const MS_PER_HOUR = 3_600_000;
const MS_PER_MINUTE = 60_000;
const MS_PER_SECOND = 1000;

/* Duração humana curta a partir de milissegundos (h/min/s) — usada nas métricas de tempo de
   revisão da moderação (célula da lista + faixa-resumo do detalhe do publisher). */
export function fmtDurationMs(ms: number): string {
  if (ms >= MS_PER_HOUR) return `${(ms / MS_PER_HOUR).toFixed(1)} h`;
  if (ms >= MS_PER_MINUTE) return `${Math.round(ms / MS_PER_MINUTE)} min`;
  return `${Math.round(ms / MS_PER_SECOND)} s`;
}

export function fmtCompactNumber(value: number): string {
  return new Intl.NumberFormat(LOCALE, { notation: 'compact' }).format(value);
}

const BYTES_PER_KB = 1024;
const BYTES_PER_MB = BYTES_PER_KB * BYTES_PER_KB;

/* Tamanho de arquivo humanizado (B/KB/MB) — tamanho do `.plnzpack` no detalhe da submissão. */
export function fmtBytes(bytes: number): string {
  if (bytes >= BYTES_PER_MB) return `${(bytes / BYTES_PER_MB).toFixed(1)} MB`;
  if (bytes >= BYTES_PER_KB) return `${Math.round(bytes / BYTES_PER_KB)} KB`;
  return `${bytes} B`;
}
